import { useContext } from "react";
import { UserContext } from "../Context/UserContext";
import CarouselMain from "./Carousel";
import GridProducts from "./GridProducts";

function Home() {
  const [,,,setDashboard] = useContext(UserContext)
  setDashboard(false)
  return (
    <>
      <CarouselMain/>
      <GridProducts/>
    </>
  );
}

export default Home;